import { render, staticRenderFns } from "./delivery copy.vue?vue&type=template&id=065b820c"
import script from "./delivery copy.vue?vue&type=script&lang=js"
export * from "./delivery copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports